import {Component, Inject, Input} from 'ng-metadata/core';
import {SearchStateService} from "../../searchState.service";
import {StringUtils} from '../../../nddUtils/stringUtils.service';
import { AuthoritySearchService } from '../../authority/authoritySearch.service';

let he = require('he');
const unescape = require('lodash/unescape');

@Component({
    "selector": 'prm-no-search-result',
    templateUrl: 'components/search/searchResult/searchResultList/noSearchResult.html',
})

    
    
export class PrmNoSearchResult{
    @Input() private term;
    private ERROR_MSG_LENGTH: number = 5;

    constructor( private searchStateService: SearchStateService,
                private stringUtils: StringUtils,
                @Inject('$translate') private $translate,
                private authoritySearchService: AuthoritySearchService){
    }

    get isSearchWithFilter() {
        return this.isAuthoritySearch ? false : this.searchStateService.getSearchObject().facets.length > 0;
    }

    private get isAuthoritySearch() {
        return this.authoritySearchService.isAuthorityState();
    }

    public getErrorLabel(label){
    	let termEncoded: string = this.term;
        if(this.containsInvalidHTML(termEncoded)){
        	termEncoded = this.term;
    		termEncoded = he.encode(termEncoded);
    	}
        return he.decode(this.$translate.instant(label , {term: he.encode(termEncoded)}));
    }
    
    getErrorSuggestionsDescriptionList() {
        let suggestionsList: Array<string> = [];
        for(let index = 1; index <= this.ERROR_MSG_LENGTH; index++){
            let currSuggestionStr: string = this.stringUtils.decode(this.$translate.instant('nui.noresults.suggestions' + index, {term: this.stringUtils.encode(this.term)}));

            // Check if string is defined, not blank, contains only white-spaces (remove them and then check if defined)
            if(currSuggestionStr && currSuggestionStr.length !== 0 && currSuggestionStr.trim()){
                suggestionsList.push(currSuggestionStr);
            }
        }
        return suggestionsList;
    }
    
    private containsInvalidHTML(text) {
        let htmlTags = /<([Aa].*[Hh][Rr][Ee][Ff]|hr|input|source|frame|link|base|img|IMG).*?>|<(a|A|audio|button|command|embed|form|source|i|iframe|src|SRC|object|rp|rt|ruby|script|SCRIPT|time|track|video).*?<\/\2>/g;
        let containsValidHTML =  htmlTags.exec(text.replace(/\r?\n|\r/gm, ''));
        return containsValidHTML != null ? containsValidHTML.length > 0 : false;
    }
    
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchResult/searchResultList/noSearchResult.directive.ts